import React from 'react';
import { LayoutGrid, Table } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { cn } from '@/lib/utils';

interface ViewSwitcherProps {
  view: 'card' | 'table';
  onViewChange: (view: 'card' | 'table') => void;
  className?: string;
}

export const ViewSwitcher = ({ view, onViewChange, className }: ViewSwitcherProps) => {
  return (
    <div className={cn("flex items-center gap-1 border rounded-md p-1", className)}>
      <Button
        variant={view === 'card' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewChange('card')}
        className="h-8 px-3"
      >
        <LayoutGrid className="h-4 w-4" />
      </Button>
      <Button
        variant={view === 'table' ? 'default' : 'ghost'}
        size="sm"
        onClick={() => onViewChange('table')}
        className="h-8 px-3"
      >
        <Table className="h-4 w-4" />
      </Button>
    </div>
  );
};